import { FC } from 'react';
import { useInstance } from '@meraki-internal/react-dependency-injection';
import { EditNoteWithQueryParamDrawer } from '../edit-note/EditNoteWithQueryParamDrawer';
import { IAction, Menu } from '../../components/Menu';
import { DeleteIcon, EditIcon } from '../../theme/Icons';
import { NotesModel } from '../model/NotesModel';
import { useIonAlert } from '@ionic/react';

export const ViewNoteMenu: FC<{model: NotesModel, noteId: string, trackingFrom?: string}> = ({ model, noteId, trackingFrom }) => {
    const [presentAlert] = useIonAlert();
    const editNoteDrawer = useInstance(EditNoteWithQueryParamDrawer);

    const note = model.getNote(noteId);

    if (!note) {
        return;
    }

    const actions: IAction[] = [];
    if (model.canEdit(note)) {
        actions.push({
            Icon:
            EditIcon,
            text: `Edit Note`,
            handler: () => editNoteDrawer.open({ noteId: note.noteId, trackingFrom })
        });
    }

    if (model.canDelete(note)) {
        const deleteNote = () => {
            const destructiveRole = 'destructive';
            presentAlert({
                header: `Delete Note?`,
                message: `This note will be deleted and cannot be recovered.`,
                cssClass: 'drawer-alert',
                onDidDismiss: (e) => {
                    if (e.detail.role === destructiveRole) {
                        editNoteDrawer.close();
                    }
                },
                buttons: [{
                    text: 'Delete',
                    role: destructiveRole,
                    handler: () => {
                        model.deleteNote(note);
                    }
                }, {
                    text: 'Cancel',
                    role: 'cancel'
                }]
            });
        };
        actions.push({
            Icon: DeleteIcon,
            role: 'destructive',
            text: `Delete Note`,
            handler: deleteNote,
            'data-type': 'delete-button'
        });
    }

    return (
        <>
            {actions.length > 0 && (
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: -8}}>
                    <div style={{flexGrow: 1}}>&nbsp;</div>
                    <div>
                        <Menu data-id="view-note-actions" actions={actions} />
                    </div>
                </div>
            )}
        </>
    );
};
